import { useState, useRef } from "react";
//import config from '../Configs/Config';
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

function Chatbot() {
  const { t } = useTranslation();
  
  const [messages, setMessages] = useState([
    { from: "bot", text: "join.bot.prompt_1" },
  ]);
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({ name: "", city: "", phone: "", termsAccepted: false });
  const [input, setInput] = useState("");
  const [completed, setCompleted] = useState(false);
  const [awaitingTerms, setAwaitingTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const messagesEndRef = useRef(null);

  const steps = ["name", "city", "phone"];
  const questions = {
    name: "join.bot.prompt_2",
    city: "join.bot.prompt_3",
    phone: "join.bot.prompt_4",
  };

  const handleSend = () => {
    if (!input.trim()) return;

    // save user reply
    setMessages([...messages, { from: "user", text: input }]);

    if (awaitingTerms) {
        if (input.toLowerCase() === "i accept" || input === "मुझे स्वीकार है") {
            setFormData({ ...formData, termsAccepted: true });
            setInput("");
            setCompleted(true);
            console.log("Collected Data:", { ...formData, termsAccepted: true });
            handleSubmitData({ ...formData, termsAccepted: true });
        } else {
            setInput("");
            setMessages((prev) => [...prev, { from: "bot", text: "join.bot.prompt_5" }]);
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
        return;
    }

    const currentField = steps[step];
    const updatedData = { ...formData, [currentField]: input };
    setFormData(updatedData);

    setInput("");

    // move to next step
    if (step < steps.length - 1) {
      const nextField = steps[step];
      setTimeout(() => {
        setMessages((prev) => [...prev, { from: "bot", text: questions[nextField] }]);
      }, 500);
      setStep(step + 1);
    } else {
      // finish
      setTimeout(() => {
        setMessages((prev) => [...prev, { from: "bot", text: questions["phone"] }]);
        setAwaitingTerms(true);
      }, 500);
      console.log("Collected Data:", updatedData);
    }
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
    e.preventDefault();
    handleSend();
    }
  };

  // Detect clicks on Terms & Conditions link
    const handleChatClick = (e) => {
        if (e.target && e.target.id === "terms-link") {
            e.preventDefault();
            setShowTerms(true);
        }
    };

  const handleSubmitData = async (formData) => {
    try {
      console.log("Collected Data final:", {formData});
      const response = await fetch("https://llxzl8knhh.execute-api.ap-south-1.amazonaws.com/prod/chat/data/save", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      setMessages((prev) => [...prev, { from: "bot", text: "join.bot.prompt_6" }]);
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      console.log("Saved:", result);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };


  return (
    <div className="section tricolor-background headerMargin">
      <h4 className="pb50">{t("join.subtitle_1")}</h4>
      
      <p className='text-left'><Trans i18nKey="join.p1.l1" /></p>

      <div className="flex-1 overflow-y-auto mb-4 space-y-2" >
        {messages.map((msg, i) => (
          <div
            key={i}
            className={`rounded-xl max-w-xs ${
              msg.from === "bot" ? "bot-text self-start" : "bg-blue-500 user-text self-end"
            }`}
          >
            {msg.from === "bot" ? (
                <Trans i18nKey={msg.text} />
            ) : (
                msg.text
            )}
          </div>
        ))}
        
      </div>
      {!completed && (
      <div className="flex gap-2">
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)} 
          onKeyDown={handleKeyDown} 
          className="flex-1 border rounded-xl p-2"
          placeholder="Type here..."
        />
        <button id="chat-btn"
          onClick={handleSend}
          className="btn-button"
        >
          {awaitingTerms ? "Submit" : "Next"}
        </button>
      </div>
      )}
      {/* Invisible div at the bottom */}
      <div className="p-4" >
        <button  id='terms-link' onClick={handleChatClick} className="text-blue-600 underline bg-transparent border-none cursor-pointer" ><Trans i18nKey="join.bot.terms_link"  /></button>
      </div>
      
      <div style={{ height: 200 }}></div>
      <div ref={messagesEndRef} ></div>
      {showTerms && (
        <div className="modal-backdrop" onClick={() => setShowTerms(false)}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
                <h2>Terms & Conditions</h2>
                <div className="modal-body">
                    
                    <p className='text-left'>By providing your information, you agree to the following:</p>
                    <ul className='text-left'>
                      <li>You are voluntarily sharing your <strong>name, location, and phone number</strong> for the purpose of supporting the political activities of<strong>ABIPP</strong></li>
                      <li>Your details will be used <strong>only for communication and coordination</strong> related to ABIPP’s campaigns and volunteer programs.</li>
                      <li>Your information will <strong>not be shared or sold</strong> to third parties outside ABIPP</li>
                      <li>You can request deletion of your data at any time by contacting the ABIPP support team</li>
                    </ul>
                    <p className="text-left">By typing <strong>“I ACCEPT”</strong>, you confirm your consent to these terms.</p>
                </div>
                <div className="modal-actions">
                    <button className="btn-button" onClick={() => setShowTerms(false)}>Close</button>
                </div>
            </div>  
        </div>
    )}
    </div>
  );
}

export default Chatbot;